import { IObjectKey } from "src/app/modules/shared/models/objects";

export const userKeys: IObjectKey[] = [
    {
        label: 'Id',
        key: 'idAnagrafico'
    },
    {
        label: 'Nome',
        key: 'nome'
    },
    {
        label: 'Data di nascita',
        key: 'dataNascita',
        pipe: {
            key: 'date',
            value: null
        }
    },
    {
        label: 'codice Fiscale',
        key: 'codiceFiscale'
    }
];